import React from 'react';
import './About.css';

function About() {
  return (
    <div className="containerCredits">
        <h2>Collaborates</h2>
        <div className="row">
      <div className="Jay">
        <h3 className="text-center">Jay</h3>
        <a href="https://github.com/JaydenB112" target="_blank" rel="noopener noreferrer">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
        //   fill="#D3D3D3" /* Set the fill color to light grey */
          width="24"
          height="24"
          style={{ marginLeft: "10px"}} /* Add margin to the right side */
        >
          <path
            fillRule="evenodd"
            d="M12 0C5.373 0 0 5.373 0 12c0 5.303 3.438 9.8 8.206 11.387.6.11.82-.26.82-.58l-.01-1.99c-3.34.73-4.04-1.61-4.04-1.61A3.17 3.17 0 004.8 17.5c-1.06-.73.08-.72.08-.72a2.52 2.52 0 011.84 1.24 2.56 2.56 0 003.48 1 2.57 2.57 0 01.76-1.61c-2.67-.3-5.47-1.34-5.47-5.94a4.65 4.65 0 011.23-3.23 4.29 4.29 0 01.12-3.17s1-.32 3.3 1.23a11.58 11.58 0 016.1 0c2.3-1.55 3.3-1.23 3.3-1.23a4.29 4.29 0 01.12 3.17 4.65 4.65 0 011.23 3.23c0 4.61-2.8 5.64-5.47 5.94a2.87 2.87 0 01.81 2.24l-.01 3.33c0 .32.21.69.82.57C20.562 21.8 24 17.303 24 12c0-6.627-5.373-12-12-12z"
          />
        </svg>
        </a>
      </div>
      {/* josh */}
      <div className="Josh">
        <h3 className="text-center">Josh</h3>
        <a href="https://github.com/jcannon04" target="_blank" rel="noopener noreferrer">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
        //   fill="#D3D3D3" /* Set the fill color to light grey */
          width="24"
          height="24"
          style={{ marginLeft: "10px"}} /* Add margin to the right side */
        >
          <path
            fillRule="evenodd"
            d="M12 0C5.373 0 0 5.373 0 12c0 5.303 3.438 9.8 8.206 11.387.6.11.82-.26.82-.58l-.01-1.99c-3.34.73-4.04-1.61-4.04-1.61A3.17 3.17 0 004.8 17.5c-1.06-.73.08-.72.08-.72a2.52 2.52 0 011.84 1.24 2.56 2.56 0 003.48 1 2.57 2.57 0 01.76-1.61c-2.67-.3-5.47-1.34-5.47-5.94a4.65 4.65 0 011.23-3.23 4.29 4.29 0 01.12-3.17s1-.32 3.3 1.23a11.58 11.58 0 016.1 0c2.3-1.55 3.3-1.23 3.3-1.23a4.29 4.29 0 01.12 3.17 4.65 4.65 0 011.23 3.23c0 4.61-2.8 5.64-5.47 5.94a2.87 2.87 0 01.81 2.24l-.01 3.33c0 .32.21.69.82.57C20.562 21.8 24 17.303 24 12c0-6.627-5.373-12-12-12z"
          />
        </svg>
        </a>
      </div>
      {/* ren */}
      <div className="Ren">
        <h3 className="text-center">Ren</h3>
        <a href="https://github.com/CodeMell" target="_blank" rel="noopener noreferrer">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
        //   fill="#D3D3D3" /* Set the fill color to light grey */
          width="24"
          height="24"
          style={{ marginLeft: "10px"}} /* Add margin to the right side */
        >
          <path
            fillRule="evenodd"
            d="M12 0C5.373 0 0 5.373 0 12c0 5.303 3.438 9.8 8.206 11.387.6.11.82-.26.82-.58l-.01-1.99c-3.34.73-4.04-1.61-4.04-1.61A3.17 3.17 0 004.8 17.5c-1.06-.73.08-.72.08-.72a2.52 2.52 0 011.84 1.24 2.56 2.56 0 003.48 1 2.57 2.57 0 01.76-1.61c-2.67-.3-5.47-1.34-5.47-5.94a4.65 4.65 0 011.23-3.23 4.29 4.29 0 01.12-3.17s1-.32 3.3 1.23a11.58 11.58 0 016.1 0c2.3-1.55 3.3-1.23 3.3-1.23a4.29 4.29 0 01.12 3.17 4.65 4.65 0 011.23 3.23c0 4.61-2.8 5.64-5.47 5.94a2.87 2.87 0 01.81 2.24l-.01 3.33c0 .32.21.69.82.57C20.562 21.8 24 17.303 24 12c0-6.627-5.373-12-12-12z"
          />
        </svg>
        </a>
      </div>
      {/* cj */}
      <div className="CJ">
        <h3 className="text-center">CJ</h3>
        <a href="https://github.com/CEEJ987" target="_blank" rel="noopener noreferrer">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
        //   fill="#D3D3D3" /* Set the fill color to light grey */
          width="24"
          height="24"
          style={{ marginLeft: "10px"}} /* Add margin to the right side */
        >
          <path
            fillRule="evenodd"
            d="M12 0C5.373 0 0 5.373 0 12c0 5.303 3.438 9.8 8.206 11.387.6.11.82-.26.82-.58l-.01-1.99c-3.34.73-4.04-1.61-4.04-1.61A3.17 3.17 0 004.8 17.5c-1.06-.73.08-.72.08-.72a2.52 2.52 0 011.84 1.24 2.56 2.56 0 003.48 1 2.57 2.57 0 01.76-1.61c-2.67-.3-5.47-1.34-5.47-5.94a4.65 4.65 0 011.23-3.23 4.29 4.29 0 01.12-3.17s1-.32 3.3 1.23a11.58 11.58 0 016.1 0c2.3-1.55 3.3-1.23 3.3-1.23a4.29 4.29 0 01.12 3.17 4.65 4.65 0 011.23 3.23c0 4.61-2.8 5.64-5.47 5.94a2.87 2.87 0 01.81 2.24l-.01 3.33c0 .32.21.69.82.57C20.562 21.8 24 17.303 24 12c0-6.627-5.373-12-12-12z"
          />
        </svg>
        </a>
      </div>
      <div className="Kaydee">
        <h3 className="text-center">Kaydee</h3>
        <a href="https://github.com/starlit-nox" target="_blank" rel="noopener noreferrer">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
        //   fill="#D3D3D3" /* Set the fill color to light grey */
          width="24"
          height="24"
          style={{ marginLeft: "10px"}} /* Add margin to the right side */
        >
          <path
            fillRule="evenodd"
            d="M12 0C5.373 0 0 5.373 0 12c0 5.303 3.438 9.8 8.206 11.387.6.11.82-.26.82-.58l-.01-1.99c-3.34.73-4.04-1.61-4.04-1.61A3.17 3.17 0 004.8 17.5c-1.06-.73.08-.72.08-.72a2.52 2.52 0 011.84 1.24 2.56 2.56 0 003.48 1 2.57 2.57 0 01.76-1.61c-2.67-.3-5.47-1.34-5.47-5.94a4.65 4.65 0 011.23-3.23 4.29 4.29 0 01.12-3.17s1-.32 3.3 1.23a11.58 11.58 0 016.1 0c2.3-1.55 3.3-1.23 3.3-1.23a4.29 4.29 0 01.12 3.17 4.65 4.65 0 011.23 3.23c0 4.61-2.8 5.64-5.47 5.94a2.87 2.87 0 01.81 2.24l-.01 3.33c0 .32.21.69.82.57C20.562 21.8 24 17.303 24 12c0-6.627-5.373-12-12-12z"
          />
        </svg>
        </a>
      </div>
      </div>

    </div>
  );
}

export default About;